import BaseStrategy from './BaseStrategy';

const WarpDrive = () => <BaseStrategy authStep="warpdrive" />;

export default WarpDrive;
